import { useEffect } from 'react';

export function useScrollLock(isOpen: boolean) {
    useEffect(() => {
        let addResetPositionTimeoutId: ReturnType<typeof setTimeout> | undefined;
        let removeResetPositionTimeoutId: ReturnType<typeof setTimeout> | undefined;

        if (isOpen) {
            document.body.classList.add('ReactModal__Body--checkoutIsOpened');

            // adding/removing ReactModal__Body--resetPosition is needed to fix iframe's UI issue in a webview
            addResetPositionTimeoutId = setTimeout(
                () => document.body.classList.add('ReactModal__Body--resetPosition'),
                0
            );
            removeResetPositionTimeoutId = setTimeout(
                () => document.body.classList.remove('ReactModal__Body--resetPosition'),
                100
            );
        } else {
            document.body.classList.remove('ReactModal__Body--checkoutIsOpened');
        }

        return () => {
            addResetPositionTimeoutId && clearTimeout(addResetPositionTimeoutId);
            removeResetPositionTimeoutId && clearTimeout(removeResetPositionTimeoutId);
            document.body.classList.remove('ReactModal__Body--checkoutIsOpened');
        };
    }, [isOpen]);
}
